<template>
  <div class="logo_text_lemontree" :style="{ 'width': width, 'height': `${height}px` }">
    <svg
      class="svg_logo_text"
      xmlns="http://www.w3.org/2000/svg"
      :width="width"
      :height="`${height}px`"
      viewBox="0 0 160 59"
      fill="none">
      <path d="M99.7756,27.2000459 L91.6696,27.2000459 L91.6696,59 L79.7988,59 L79.7988,27.2000459 L74.5344,27.2000459 L74.5344,17.9452601 L79.7988,17.9452601 L79.7988,15.6914902 C79.7988,8.97162987 84.3644,0 99.275,0 L99.275,10.2912248 C94.6316,10.2912248 91.6676,12.3148601 91.6676,16.0965937 L91.6676,17.9471223 L99.7756,17.9471223 L99.7756,27.2000459 Z M17.1352,27.2000459 L25.2432,27.2000459 L25.2432,17.9471223 L17.1352,17.9471223 L17.1352,16.0965937 C17.1352,12.3148601 20.0994,10.2912248 24.7428,10.2912248 L24.7428,0.0019643445 C9.83006,0.0019643445 5.26436,8.97359221 5.26436,15.6914902 L5.26436,17.9452601 L0,17.9452601 L0,27.2000459 L5.26436,27.2000459 L5.26436,59 L17.1352,59 L17.1352,27.2000459 Z M40.6338,31.1215263 L28.9324,31.1215263 L28.9324,59 L40.6338,59 L40.6338,31.1215263 Z M117.1844,6.82212438 C117.1844,10.3553013 114.2092,13.2194798 110.5392,13.2194798 C106.8692,13.2194798 103.894,10.3553013 103.894,6.82212438 C103.894,3.28896747 106.8692,0.424786994 110.5392,0.424786994 C114.2092,0.424786994 117.1844,3.28896747 117.1844,6.82212438 Z M71.4558,17.3021926 L71.4558,29.1311508 L68.363,29.1311508 C59.4236,29.1311508 57.246,34.7204217 57.246,35.8766016 L57.246,58.9979976 L45.5448,58.9979976 L45.5448,17.9471223 L56.7272,17.9471223 L56.7272,24.8676622 C58.5004,21.4083334 62.4676,17.3021926 71.4558,17.3021926 Z M104.6884,17.9471223 L116.3898,17.9471223 L116.3898,59 L104.6884,59 L104.6884,17.9471223 Z M34.7832,26.3938838 C38.3438,26.3938838 41.2302,23.6149671 41.2302,20.1870758 C41.2302,16.7593848 38.3438,13.9805682 34.7832,13.9805682 C31.2224,13.9805682 28.336,16.7593848 28.336,20.1870758 C28.336,23.6149671 31.2224,26.3938838 34.7832,26.3938838 Z M160,42.0950235 C160,33.9907508 160,27.325796 155.5302,22.3326366 L155.5284,22.3326366 C151.5754,17.9196896 146.9872,17.3237583 143.774,17.3217523 C138.9386,17.3178913 134.1072,20.3799059 132.7078,23.1095639 L132.7078,17.9472625 L121.2988,17.9472625 L121.2988,59 L132.9734,59 L132.9734,56.6499952 L133.0552,36.4665057 C133.0552,32.3131486 136.4442,28.4076873 140.722,28.4076873 C146.1046,28.4076873 148.456,32.3898401 148.456,39.3733751 L148.456,59 L160,59 L160,42.0950235 Z" :fill="logoColor"/>
    </svg>
  </div>
</template>

<script>
export default {
  name:'FirfinLogoText',
  props: {
    // width: {
    //   type: [Number, String],
    //   default: 80
    // },
    height: {
      type: [Number, String],
      default: 59
    },
    logoColor:{
      type: String,
      default: '#232323'
    }
  },
  computed:{
    width(){
      return ( ( 160/ 59 )  * this.height )+'px';
    }
  }
}
</script>

<style scoped>
.svg_logo_text{display:block}
</style>